import useSWRImmutable from 'swr/immutable';

export const USE_PREVIEW_KEY = 'isPreviewKey';

export const usePreview = (): boolean => {
    const { data } = useSWRImmutable<{ isPreview: boolean }>(USE_PREVIEW_KEY);
    return data?.isPreview ?? false;
};
